import http from "../../services/http";

const getAllCampaignsApi = async () => {
  return await http("get", "v1/formularios_colaboradores/campanhas/getAll");
};

const getCampaignByIdApi = async (id) => {
  return await http("get", `v1/formularios_colaboradores/campanhas/get/${id}`);
};

const createCampaignApi = async (data) => {
  return await http("post", "v1/formularios_colaboradores/campanhas/create", data);
};

const updateCampaignApi = async (data) => {
  return await http("post", "v1/formularios_colaboradores/campanhas/update", data);
};

const deleteCampaignApi = async (id) => {
  return await http("post", "v1/formularios_colaboradores/campanhas/delete", { id: id });
};

export { getAllCampaignsApi, getCampaignByIdApi, createCampaignApi, updateCampaignApi, deleteCampaignApi };
